import React, { Suspense, useLayoutEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { Outlet, useMatches, type Params } from 'react-router-dom';
import { formatDocumentTitle } from '../hooks/useDocumentTitle';
import Authenticated from './Authenticated';
import EnvironmentBadge from './EnvironmentBadge';

function RouteOutletFallback(): React.ReactElement {
  return (
    <div
      className="d-flex justify-content-center align-items-center py-5"
      style={{ minHeight: '12rem' }}>
      <Spinner animation="border" role="status" variant="secondary">
        <span className="visually-hidden">Loading</span>
      </Spinner>
    </div>
  );
}

type MatchHandle = {
  documentTitle?: string;
  buildDocumentTitle?: (params: Readonly<Params<string>>) => string | undefined;
};

const Main: React.FC = () => {
  const matches = useMatches();

  // Set the document title based on the route handle
  useLayoutEffect(() => {
    for (let i = matches.length - 1; i >= 0; i--) {
      const match = matches[i];
      const h = match.handle as MatchHandle | undefined;
      if (h?.buildDocumentTitle) {
        const built = h.buildDocumentTitle(match.params);
        if (typeof built === 'string' && built.trim() !== '') {
          document.title = formatDocumentTitle(built);
          return;
        }
      }
      if (typeof h?.documentTitle === 'string' && h.documentTitle.trim() !== '') {
        document.title = formatDocumentTitle(h.documentTitle);
        return;
      }
    }
    document.title = 'Relcore';
  }, [matches]);

  return (
    <Authenticated navbarBrandAddon={<EnvironmentBadge />}>
      <Suspense fallback={<RouteOutletFallback />}>
        <Outlet />
      </Suspense>
    </Authenticated>
  );
};

export default Main;
